class MarqueeSection extends HTMLElement {
      swiperElement = null
      swiper = null
      pauseButton = null
      boundToggleAutoplay = null
      autoplaySpeed

      constructor () {
        super(),
            this.swiperElement = this.querySelector('.js-init-swiper'),
            this.pauseButton = this.querySelector('.js-marquee__controls__button__pause'),
            this.boundToggleAutoplay = this.toggleAutoplay.bind(this),
            this.autoplaySpeed = this.dataset.speed ? parseInt(this.dataset.speed, 10) : null
      }

      initSwiper () {
        if (!this.swiperElement) return
        this.swiper && this.swiper.destroy(true, true)
        let sliderSettings = {
          autoplay: this.autoplaySpeed ? { delay: 0, disableOnInteraction: true } : void 0,
          loop: true,
          modules: [Swiper.Navigation, Swiper.Autoplay],
          speed: this.autoplaySpeed || 1e3,
          slidesPerView: 1.08,
          spaceBetween: 12,
          slidesPerGroup: 1,
          navigation: {
            nextEl: this.querySelector('.js-marquee__controls__button__next'),
            prevEl: this.querySelector('.js-marquee__controls__button__prev')
          },
          breakpoints: { 768: { slidesPerView: 3.34, spaceBetween: 24, slidesPerGroup: 1, loop: true } },
          on: {
            navigationNext: () => {this.checkAutoplayState(new Event('click'))},
            navigationPrev: () => {
              this.checkAutoplayState(new Event(
                  'click'))
            },
            autoplayStart: currentSwiper => {currentSwiper && (currentSwiper.params.speed = this.autoplaySpeed || 3e3)},
            autoplayStop: () => {
              let timeLeft = this.swiper?.autoplay.timeLeft || 0, setManualSpeed = () => this.swiper.params.speed = 1e3
              setManualSpeed(),
              this.swiper && (timeLeft ? setTimeout(() => {this.swiper && setManualSpeed()}, timeLeft) : setManualSpeed())
            }
          }
        }
        this.swiper = new Swiper(this.swiperElement, sliderSettings)
      }

      toggleAutoplayState (target) {
        this.swiper && (this.swiper.autoplay.running ? (this.swiper.autoplay.stop(), target.classList.add('active')) : (this.swiper.params.speed = this.autoplaySpeed || 3e3, this.swiper.autoplay.start(), target.classList.remove('active')))
      }

      toggleAutoplay (event) {
        let target = event.target
        'click' === event.type ? this.swiper && target instanceof HTMLElement && this.toggleAutoplayState(target) : 'keydown' === event.type && event instanceof KeyboardEvent && ('Enter' === event.key || ' ' === event.key) && (event.preventDefault(), this.swiper && target instanceof
        HTMLElement && this.toggleAutoplayState(target))
      }

      checkAutoplayState (event) {event instanceof Event && this.swiper && this.swiper.autoplay.running && (this.pauseButton?.classList.add('active'), this.swiper.autoplay.stop())}

      initListeners () {
        this.pauseButton &&
        this.boundToggleAutoplay && (this.pauseButton.addEventListener('click', this.toggleAutoplay.bind(this)), this.pauseButton.addEventListener('keydown', this.toggleAutoplay.bind(this)))
      }

      removeListeners () {
        this.pauseButton && this.boundToggleAutoplay &&
        (this.pauseButton.removeEventListener('click', this.toggleAutoplay.bind(this)), this.pauseButton.removeEventListener('keydown', this.toggleAutoplay.bind(this)))
      }

      connectedCallback () {this.initSwiper(), this.initListeners()}

      disconnectedCallback () {
        this.swiper && (this.swiper.destroy(true, true), this.swiper = null), this.removeListeners()
      }
    }

    customElements.get('marquee-section') || customElements.define('marquee-section', MarqueeSection)
